import { Controller } from "@hotwired/stimulus";
import animatedScrollTo from "animated-scroll-to";

export default class extends Controller {
    // static values = {}

    connect() {
        /** @param {Event} event */
        this.handler = (event) => {
            event.preventDefault();

            animatedScrollTo(this.element.href);
        }

        this.element.addEventListener('click', this.handler)
    }

    disconnect() {
        this.element.removeEventListener('click', this.handler)
    }
}
